<header class="login-header">
    <!-- <div class="container">
        <div class="row align-items-center">
            <div class="col-md-6 col-6">
                <a class="navbar-brand brand-logo"href="javascript:void(0)" [routerLink]="['/home']">
                    <img src="assets/img/{{env.host.name}}/logo.png" alt="logo" />
                </a>
            </div>
            <div class="col-md-6 col-6">
                <button class="btn btn-block btn-gradient-primary btn-sm font-weight-medium auth-form-btn btn-login" (click)="openLogin('')">sign in</button>
            </div>
        </div>
    </div> -->
    <app-topnav></app-topnav>
</header>

<!-- top-nav   -->
<app-sportsnav></app-sportsnav>



<section class="login-slider">
    <div id="carouselExampleControls" class="carousel slide" data-ride="carousel" data-interval="3000">
        <div class="carousel-inner" *ngIf="!env.isMobile">
            <div class="carousel-item" [ngClass]="{'active' : i == 0}" *ngFor="let item of env.desktopBannerList; let i=index;trackBy:trackByIndex;">
                <img class="img-fluid" [src]="item" alt="slide-{{i}}">
            </div>
        </div>
        <div class="carousel-inner" *ngIf="env.isMobile">
            <div class="carousel-item" [ngClass]="{'active' : i == 0}" *ngFor="let item of env.mobileBannerList; let i=index;trackBy:trackByIndex;">
                <img class="img-fluid" [src]="item" alt="slide-{{i}}">
            </div>
        </div>
            <!-- <div class="carousel-item">
                <img class="d-block w-100" src="assets/img/webfiles/banner1.png" alt="Second slide">
            </div>
            <div class="carousel-item">
                <img class="d-block w-100" src="assets/img/webfiles/banner3.png" alt="Third slide">
            </div>
            <div class="carousel-item">
                <img class="d-block w-100" src="assets/img/webfiles/banner4.png" alt="Third slide">
            </div>
            <div class="carousel-item">
                <img class="d-block w-100" src="assets/img/webfiles/banner5.png" alt="Third slide">
            </div>
            <div class="carousel-item">
                <img class="d-block w-100" src="assets/img/webfiles/banner6.png" alt="Third slide">
            </div> -->
        <a class="carousel-control-prev" href="#carouselExampleControls" role="button" data-slide="prev">
            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
        </a>
        <a class="carousel-control-next" href="#carouselExampleControls" role="button" data-slide="next">
            <span class="carousel-control-next-icon" aria-hidden="true"></span>
        </a>
    </div>
</section>
<!-- upcomming -->
<app-upcoming></app-upcoming>

<section class="sportsBg">
    <div class="container">
        <h1>games</h1>
        <div class="row">
            <div class="col-md-3 col-6">
                <div class="sbDiv">
                    <a href="javascript:void(0)" (click)="confirmSport(4)">
                        <img class="img-fluid" src="https://speedcdn.io/assets/parker-client/cricket.jpg">
                    </a>
                    <h2>cricket</h2>
                </div>
            </div>

            <div class="col-md-3 col-6">
                <div class="sbDiv">
                    <a href="javascript:void(0)" (click)="confirmSport(1)">
                        <img class="img-fluid" src="https://speedcdn.io/assets/parker-client/football.jpg">
                    </a>
                    <h2>football</h2>
                </div>
            </div>

            <div class="col-md-3 col-6">
                <div class="sbDiv">
                    <a href="javascript:void(0)" (click)="confirmSport(2)">
                        <img class="img-fluid" src="https://speedcdn.io/assets/parker-client/tennis.jpg">
                    </a>
                    <h2>tennis</h2>
                </div>
            </div>
            <div class="col-md-3 col-6">
                <div class="sbDiv">
                    <a href="javascript:void(0)" (click)="confirmSport(2378961)">
                        <img class="img-fluid" src="https://speedcdn.io/assets/parker-client/election.png">
                    </a>
                    <h2><em>election</em></h2>
                    <!-- class="highlightNew" -->

                    <!-- <span class="betopen">bet open</span> -->
                </div>
            </div>
            <div class="col-md-3 col-6">
                <div class="sbDiv">
                    <a href="javascript:void(0)" (click)="confirmSport(7)">
                        <img class="img-fluid" src="https://speedcdn.io/assets/parker-client/horseracing.jpg">
                    </a>
                    <h2>Horse Racing</h2>
                </div>
            </div>
            <div class="col-md-3 col-6">
                <div class="sbDiv">
                    <a href="javascript:void(0)" (click)="confirmSport(4339)">
                        <img class="img-fluid" src="https://speedcdn.io/assets/parker-client/grayhound.jpg">
                    </a>
                    <h2>Grayhound Racing</h2>
                </div>
            </div>

            <div class="col-md-3 col-6">
                <div class="sbDiv">
                    <a href="javascript:void(0)" (click)="confirmCasino(99999)">
                        <img class="img-fluid" src="https://speedcdn.io/assets/parker-client/casino.jpg">
                    </a>
                    <h2>casino</h2>
                </div>
            </div>

            <div class="col-md-3 col-6">
                <div class="sbDiv">
                    <a href="javascript:void(0)" (click)="confirmCasino(99995)">
                        <img class="img-fluid" src="https://speedcdn.io/assets/parker-client/icasino.jpg">
                    </a>
                    <h2>i casino</h2>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="casinoBg">
    <div class="container">
        <h1>Card Games</h1>
        <div class="row cg_rows">

            <!-- new added -->
            <div class="col-md-2 col-6 position-relative" (click)="confirmCasinoDetail1(99995, 11108)">
                <img class="img-fluid" src="https://speedcdn.io/assets/parker-client/landing_casino/aviator.png">
                <a>aviator</a>
                <span class="new_launch">new launch</span>
            </div>
            <div class="col-md-2 col-6 position-relative" (click)="confirmCasinoDetail1(99999, 67720)">
                <img class="img-fluid" src="https://speedcdn.io/assets/parker-client/landing_casino/so.png">
                <a>super over</a>
                <span class="new_launch">new launch</span>
            </div>


            <div class="col-md-2 col-6" (click)="confirmCasinoDetail1(99999, 99999)">
                <img class="img-fluid" src="https://speedcdn.io/assets/parker-client/landing_casino/lobby.png">
                <a>Lobby</a>
            </div>
            <div class="col-md-2 col-6" (click)="confirmCasinoDetail1(99999, 56767)">
                <img class="img-fluid" src="https://speedcdn.io/assets/parker-client/landing_casino/32card.jpg">
                <a>teenpatti</a>
            </div>
            <div class="col-md-2 col-6" (click)="confirmCasinoDetail1(99999, 56768)">
                <img class="img-fluid" src="https://speedcdn.io/assets/parker-client/landing_casino/teenpatti_t20.jpg">
                <a>teenpatti t20</a>
            </div>
            <div class="col-md-2 col-6" (click)="confirmCasinoDetail1(99999, 67564)">
                <img class="img-fluid" src="https://speedcdn.io/assets/parker-client/landing_casino/poker.jpg">
                <a>poker</a>
            </div>
            <div class="col-md-2 col-6" (click)="confirmCasinoDetail1(99999, 98790)">
                <img class="img-fluid" src="https://speedcdn.io/assets/parker-client/landing_casino/dt.jpg">
                <a>dragon tiger</a>
            </div>
            <div class="col-md-2 col-6" (click)="confirmCasinoDetail1(99999, 87564)">
                <img class="img-fluid" src="https://speedcdn.io/assets/parker-client/landing_casino/ab.jpg">
                <a>andar bahar</a>
            </div>
            <div class="col-md-2 col-6" (click)="confirmCasinoDetail1(99999, 98789)">
                <img class="img-fluid" src="https://speedcdn.io/assets/parker-client/landing_casino/7updown.jpg">
                <a>7Up Down</a>
            </div>
            <div class="col-md-2 col-6" (click)="confirmCasinoDetail1(99999, 56967)">
                <img class="img-fluid" src="https://speedcdn.io/assets/parker-client/landing_casino/32card.png">
                <a>32 cards</a>
            </div>
        </div>
    </div>
</section>

<section class="casinoBg">
    <div class="container">
        <h1>live casino</h1>
        <div class="row">

            <div class="col-md-2 col-6" (click)="redirectICasinoLobby('99995:evolution-gaming')">
                <img class="img-fluid" src="https://speedcdn.io/assets/parker-client/landing_casino/evolution.jpg">
                <a>evolution</a>
            </div>
            <div class="col-md-2 col-6" (click)="redirectICasinoLobby('99995:ezugi')">
                <img class="img-fluid" src="https://speedcdn.io/assets/parker-client/landing_casino/ezugi.jpg">
                <a>ezugi</a>
            </div>
            <div class="col-md-2 col-6" (click)="redirectICasinoLobby('99995:onetouch')">
                <img class="img-fluid" src="https://speedcdn.io/assets/parker-client/landing_casino/onetouch.jpg">
                <a>onetouch</a>
            </div>
            <div class="col-md-2 col-6" (click)="redirectICasinoLobby('99995:bombay-live')">
                <img class="img-fluid" src="https://speedcdn.io/assets/parker-client/landing_casino/pplive.jpg">
                <a>bombay live</a>
            </div>
            <div class="col-md-2 col-6" (click)="redirectICasinoLobby('99995:betgamestv')">
                <img class="img-fluid" src="https://speedcdn.io/assets/parker-client/landing_casino/bg.png">
                <a>betgamestv</a>
            </div>
            <div class="col-md-2 col-6" (click)="redirectICasinoLobby('99995:gamzix')">
                <img class="img-fluid" src="https://speedcdn.io/assets/parker-client/landing_casino/gamzix.jpg">
                <a>gamzix</a>
            </div>
            
            <!-- <div class="col-md-2 col-6" (click)="confirmCasinoDetail(99995, 5160)">
                <img class="img-fluid" src="assets/img/casino/evolution.jpg">
                <a>evolution</a>
            </div>
            <div class="col-md-2 col-6" (click)="confirmCasinoDetail(99995, 5251)">
                <img class="img-fluid" src="assets/img/casino/ezugi.jpg">
                <a>ezugi</a>
            </div>
            <div class="col-md-2 col-6" (click)="confirmCasinoDetail(99995, 9039)">
                <img class="img-fluid" src="assets/img/casino/onetouch.jpg">
                <a>onetouch</a>
            </div>
            <div class="col-md-2 col-6" (click)="confirmCasinoDetail(99995, 9002)">
                <img class="img-fluid" src="assets/img/casino/pplive.jpg">
                <a>bombay live</a>
            </div>
            <div class="col-md-2 col-6" (click)="confirmCasinoDetail(99995, 5271)">
                <img class="img-fluid" src="assets/img/casino/bg.png">
                <a>betgamestv</a>
            </div>
            <div class="col-md-2 col-6" (click)="confirmCasinoDetail(99995, 9099)">
                <img class="img-fluid" src="assets/img/casino/vivo.jpg">
                <a>gamzix</a>
            </div> -->

            <!-- new added -->
            <div class="col-md-2 col-6 position-relative" (click)="confirmCasinoDetail(99995, 11108)">
                <img class="img-fluid" src="https://speedcdn.io/assets/parker-client/landing_casino/aviator.png">
                <a>aviator</a>
                <span class="new_launch">new launch</span>
            </div>
            <div class="col-md-2 col-6" (click)="redirectICasinoLobby('99995:spribe')">
                <img class="img-fluid" src="https://speedcdn.io/assets/parker-client/landing_casino/spribe.png">
                <a>spribe</a>
            </div>
            <div class="col-md-2 col-6" (click)="redirectICasinoLobby('99995:kingmaker')">
                <img class="img-fluid" src="https://speedcdn.io/assets/parker-client/landing_casino/kingmaker.png">
                <a>king maker</a>
            </div>
            <div class="col-md-2 col-6 position-relative" (click)="redirectICasinoLobby('99995:ae-sexy')">
                <img class="img-fluid" src="https://speedcdn.io/assets/parker-client/landing_casino/aesexy.png">
                <a>Ae sexy</a>
                <span class="new_launch">new launch</span>
            </div>
        </div>
    </div>
</section>

<section class="casinoBg">
    <div class="container">
        <h1>Royal Games</h1>
        <div class="row cg_rows">
            <div class="col-md-2 col-6" (click)="confirmCasinoDetail(99995, 11103)">
                <img class="img-fluid" src="https://speedcdn.io/assets/parker-client/landing_casino/lobby.jpg">
                <a>Lobby</a>
            </div>
            <div class="col-md-2 col-6" (click)="confirmCasinoDetail(99995, 11091)">
                <img class="img-fluid" src="https://speedcdn.io/assets/parker-client/landing_casino/teen_patti.jpg">
                <a>teenpatti</a>
            </div>
            <div class="col-md-2 col-6" (click)="confirmCasinoDetail(99995, 11098)">
                <img class="img-fluid" src="https://speedcdn.io/assets/parker-client/landing_casino/bollywood_casino.jpg">
                <a>bollywood casino</a>
            </div>
            <div class="col-md-2 col-6" (click)="confirmCasinoDetail(99995, 11106)">
                <img class="img-fluid" src="https://speedcdn.io/assets/parker-client/landing_casino/2card_tp.jpg">
                <a>2 cards teenpatti</a>
            </div>
            <div class="col-md-2 col-6" (click)="confirmCasinoDetail(99995, 11093)">
                <img class="img-fluid" src="https://speedcdn.io/assets/parker-client/landing_casino/cricket_war.jpg">
                <a>cricket war</a>
            </div>
            <div class="col-md-2 col-6" (click)="confirmCasinoDetail(99995, 11104)">
                <img class="img-fluid" src="https://speedcdn.io/assets/parker-client/landing_casino/lucky7.jpg">
                <a>lucky7</a>
            </div>
            <div class="col-md-2 col-6" (click)="confirmCasinoDetail(99995, 11096)">
                <img class="img-fluid" src="https://speedcdn.io/assets/parker-client/landing_casino/casino_war.jpg">
                <a>casino war</a>
            </div>
            <div class="col-md-2 col-6" (click)="confirmCasinoDetail(99995, 11102)">
                <img class="img-fluid" src="https://speedcdn.io/assets/parker-client/landing_casino/muflis_teenpatti.jpg">
                <a>muflis teen patti</a>
            </div>
        </div>
    </div>
</section>

<!-- footer -->
<footer class="footerPage">
    <div class="container">
        <div class="row">
            <div class="col-md-3 pt-4">
                <img class="img-fluid" src="assets/img/{{env.host.name}}/logo.png" width="265px" />
            </div>
            <div class="col-md-2 pt-4">
                <h5>
                    <span style="border-bottom: solid 1px; color: #edb849; text-transform: uppercase; font-weight: bolder;">Menu </span>
                </h5>
                <a href="javascript:void(0);" class="text-white">About Us</a><br />
                <a (click)="openModal(privacyModal)" class="text-white">Privacy Policy</a><br />
                <a (click)="openModal(rulesModal)" class="text-white">Rules</a>
            </div>
            <div class="col-md-2 pt-4">
                <h5><span style="border-bottom: solid 1px; color: #edb849; text-transform: uppercase; font-weight: bolder;"> Payment Methods </span></h5>
                <div class="row d-none d-sm-flex">
                    <div class="col-4 p-0"><img src="http://speedcdn.io/assets/kesar-client/landing/bhim_b.png" style="opacity: unset; background: none;" class="img-thumbnail" /></div>
                    <div class="col-4 p-0"><img src="http://speedcdn.io/assets/kesar-client/landing/upi_b.png" style="opacity: unset; background: none;" class="img-thumbnail" /></div>
                    <div class="col-4 p-0"><img src="http://speedcdn.io/assets/kesar-client/landing/phonepe_b.png" style="opacity: unset; background: none;" class="img-thumbnail" /></div>
                    <div class="col-4 p-0 mt-3"><img src="http://speedcdn.io/assets/kesar-client/landing/paytm_b.png" style="opacity: unset; background: none;" class="img-thumbnail" /></div>
                    <div class="col-4 p-0 mt-3"><img src="http://speedcdn.io/assets/kesar-client/landing/gpay_b.png" style="opacity: unset; background: none;" class="img-thumbnail" /></div>
                    <div class="col-4 p-0 mt-3"><img src="http://speedcdn.io/assets/kesar-client/landing/bank_b.png" style="opacity: unset; background: none;" class="img-thumbnail" /></div>
                </div>
                <div class="row d-sm-none d-inline-flex m-0">
                    <div class="col-4 p-0"><img src="http://speedcdn.io/assets/kesar-client/landing/bhim.png" style="opacity: unset; background: none;" class="img-thumbnail" /></div>
                    <div class="col-4 p-0"><img src="http://speedcdn.io/assets/kesar-client/landing/upi.png" style="opacity: unset; background: none;" class="img-thumbnail" /></div>
                    <div class="col-4 p-0"><img src="http://speedcdn.io/assets/kesar-client/landing/phone_pay.png" style="opacity: unset; background: none;" class="img-thumbnail" /></div>
                    <div class="col-4 p-0 mt-3"><img src="http://speedcdn.io/assets/kesar-client/landing/paytm.png" style="opacity: unset; background: none;" class="img-thumbnail" /></div>
                    <div class="col-4 p-0 mt-3"><img src="http://speedcdn.io/assets/kesar-client/landing/gpay.png" style="opacity: unset; background: none;" class="img-thumbnail" /></div>
                    <div class="col-4 p-0 mt-3"><img src="http://speedcdn.io/assets/kesar-client/landing/bank.png" style="opacity: unset; background: none;" class="img-thumbnail" /></div>
                </div>
            </div>
            <div class="col-md-2 pt-4">
                <h5>
                    <span style="border-bottom: solid 1px; color: #edb849; text-transform: uppercase; font-weight: bolder;">Scan Qr </span>
                </h5>
                <img class="img-fluid pb-1" src="assets/img/{{env.host.name}}/qr-code.png" width="100" />

                <h5>
                    <span style="border-bottom: solid 1px; color: #edb849; text-transform: uppercase; font-weight: bolder;">Game Therapy</span>
                </h5>
                <img class="img-fluid" (click)="openModal(ruleModal)" src="https://speedcdn.io/assets/parker-client/18-plus-color-footer.png" style="cursor: pointer;" />
                <a href="https://www.gamcare.org.uk/" target="_blank">
                    <img class="img-fluid" src="https://speedcdn.io/assets/parker-client/gamecare.png" />
                </a>
                <a href="https://www.gamblingtherapy.org/en" target="_blank"> 
                    <img class="img-fluid" src="https://speedcdn.io/assets/parker-client/gt.png" />
                </a>
            </div>
            <div class="col-md-3 pt-4">
                <h5><span style="border-bottom: solid 1px; color: #edb849; text-transform: uppercase; font-weight: bolder;"> Follow Us </span></h5>

                <a href="#" target="_blank">
                    <img src="http://speedcdn.io/assets/kesar-client/landing/facebook.png" />
                </a>
                <a href="#" target="_blank">
                    <img src="http://speedcdn.io/assets/kesar-client/landing/whatsapp.png" />
                </a>
                <a href="#" target="_blank">
                    <img src="http://speedcdn.io/assets/kesar-client/landing/telegram.png" />
                </a>
                <a href="#" target="_blank">
                    <img src="http://speedcdn.io/assets/kesar-client/landing/instagram.png" />
                </a>
                <a href="#" target="_blank">
                    <img src="http://speedcdn.io/assets/kesar-client/landing/youtube.png" />
                </a>
                <img class="img-fluid" src="https://speedcdn.io/assets/parker-client/ssl.png" /> <br />
                <a href="javascript:void(0);" class="text-white">
                    <strong>100% SAFE</strong><br />
                    Protected connection and encrypted data.
                </a>
            </div>
            <hr class="mt-2" />
            <div class="col-md-12">
                <p>© Copyright 2024-2025 <b>{{env.host.dName}}.</b> All rights reserved</p>
            </div>
        </div>
    </div>
</footer>

<ng-template #ruleModal>
    <div class="modal-header">
        <h4 class="modal-title mt-0">18 Plus Rules</h4>
        <button type="button" class="close" (click)="modalRef?.hide()">×</button>
    </div>
    <div class="modal-body">
        <div id="age18" class="">
            <ul style="line-height:30px; font-size:13px;">
            <li>It is illegal for anybody under the age of 18 to gamble</li>
            <li>It is an offence for anyone under the age of 18 to open an account or to gamble on PARKER777</li>
            <li>PARKER777 takes its age-verification responsibilities very seriously</li>
            <li>We carry out age-verification checks on all customers who use payment mechanisms which are available to under 18s and additionally perform random age-verification checks on customers using other forms of funding mechanisms</li>
            <li>We may ask for information to verify your age and could restrict or suspend your account until your age is confirmed</li>
            <li>PARKER777 advises and encourages its customers to prevent minors from accessing gambling websites.</li>
            <li>We encourage parents consider the use of internet use protection tools</li>
            <li>You may find following links useful <a href="https://www.cyberpatrol.com/" target="_blank">cyberpatrol.com</a></li>
            </ul>
        </div>
    </div>
</ng-template>
<ng-template #rulesModal>
    <div class="modal-header">
        <h4 class="modal-title mt-0">Rules</h4>
        <button type="button" class="close" (click)="modalRef?.hide()">×</button>
    </div>
    <div class="modal-body">
        If a sport-specific rule contradicts a general rule, then the general rule will not apply.<br /><br />

        The winner of an event will be determined on the date of the event’s settlement; we do not recognise protested or overturned decisions for wagering purposes. The result of an event suspended after the start of competition will be decided according to the wagering rules specified for that sport by us.<br /><br />

        All results posted shall be final after 72 hours and no queries will be entertained after that period of time. Within 72 hours after results are posted, the company will only reset/correct the results due to human error, system error or mistakes made by the referring results source.<br /><br />


        Minimum and maximum wager amounts on all sporting events will be determined by us and are subject to change without prior written notice. We also reserve the right to adjust limits on individual Accounts as well.<br /><br />



        Customers are solely responsible for their own account transactions. Please be sure to review your wagers for any mistakes before sending them in. Once a transaction is complete, it cannot be changed. We do not take responsibility for missing or duplicate wagers made by the Customer and will not entertain discrepancy requests because a play is missing or duplicated. Customers may review their transactions in the My Account section of the site after each session to ensure all requested wagers were accepted.<br /><br />



        For a wager to have action on any named contestant in a Yes/No Proposition, the contestant must enter and compete in the event.<br /><br />



        We attempt to follow the normal conventions to indicate home and away teams by indicating the home and away team by means of vertical placement on the desktop site version. This means in American Sports we would place the home team on the bottom. For Non-US sports, we would indicate the home team on top. In the case of a neutral venue, we attempt to include the letter “N” next to the team names to indicate this. For the Asian and mobile versions, we do not distinguish between European and American Sports. On the Asian and mobile versions of the site, the home team is always listed first. However, we do not guarantee the accuracy of this information and unless there is an official venue change subsequent to bets being placed, all wagers have action.<br /><br />



        A game/match will have action regardless of the League heading that is associated with the matchup. For example, two teams from the same League are playing in a Cup competition. If the matchup is mistakenly placed in the League offering, the game/match will still have action, as long as the matchup is correct. In other words, a matchup will have action as long as the two teams are correct, and regardless of the League header in which it is placed on our Website.<br /><br />



        If an event is not played on the same date as announced by the governing body, then all wagers on the event have no action. If an event is posted by us, with an incorrect date, all wagers have action based on the date announced by the governing body.<br /><br />



        site reserves the right to remove events, markets and any other product from the website.<br /><br />



        site eserves the right to restrict the casino access of any player without prior notice.<br /><br />



        In all futures wagering (for example, total season wins, Super Bowl winner, etc.), the winner as determined by the Governing Body will also be declared the winner for betting purposes except when the minimum number of games required for the future to have “action” has not been completed.<br /><br />



       <h4><b> Communications and Notices</b></h4><br />

        All communications and notices to be given under these terms by you to us shall be sent to [email protected]<br /><br />



        All communications and notices to be given under these terms by us to you shall, unless otherwise specified in these terms, be either posted on the Website and/or sent to the Registered Email Address we hold on our system for the relevant Customer. The method of such communication shall be in our sole and exclusive discretion.<br /><br />



        All communications and notices to be given under these terms by either you or us shall be in writing in the English language when the service is not operated by site, and must be given to and from the Registered Email Address in your Account.<br /><br />



        <h4><b> Matters Beyond Our Control</b></h4><br />

        We cannot be held liable for any failure or delay in providing the service due to an event of Force Majeure which could reasonably be considered to be outside our control despite our execution of reasonable preventative measures such as: an act of God; trade or labour dispute; power cut; act, failure or omission of any government or authority; obstruction or failure of telecommunication services; or any other delay or failure caused by a third party, and we will not be liable for any resulting loss or damage that you may suffer. In such an event, we reserve the right to cancel or suspend the Service without incurring any liability.<br /><br />



        <h4><b> Liability</b></h4><br />

        TO THE EXTENT PERMITTED BY APPLICABLE LAW, WE WILL NOT COMPENSATE YOU FOR ANY REASONABLY FORESEEABLE LOSS OR DAMAGE (EITHER DIRECT OR INDIRECT) YOU MAY SUFFER IF WE FAIL TO CARRY OUT OUR OBLIGATIONS UNDER THESE TERMS UNLESS WE BREACH ANY DUTIES IMPOSED ON US BY LAW (INCLUDING IF WE CAUSE DEATH OR PERSONAL INJURY BY OUR NEGLIGENCE) IN WHICH CASE WE SHALL NOT BE LIABLE TO YOU IF THAT FAILURE IS ATTRIBUTED TO<br /><br />



        <h4><b> (I) YOUR OWN FAULT;</b></h4><br />





        (II) A THIRD PARTY UNCONNECTED WITH OUR PERFORMANCE OF THESE TERMS (FOR INSTANCE PROBLEMS DUE TO COMMUNICATIONS NETWORK PERFORMANCE, CONGESTION, AND CONNECTIVITY OR THE PERFORMANCE OF YOUR COMPUTER EQUIPMENT); OR<br /><br />

        (III) ANY OTHER EVENTS WHICH NEITHER WE NOR OUR SUPPLIERS COULD HAVE FORESEEN OR FORESTALLED EVEN IF WE OR THEY HAD TAKEN REASONABLE CARE. AS THIS SERVICE IS FOR CONSUMER USE ONLY WE WILL NOT BE LIABLE FOR ANY BUSINESS LOSSES OF ANY KIND.<br /><br />



        IN THE EVENT THAT WE ARE HELD LIABLE FOR ANY EVENT UNDER THESE TERMS, OUR TOTAL AGGREGATE LIABILITY TO YOU UNDER OR IN CONNECTION WITH THESE TERMS SHALL NOT EXCEED<br /><br />



        (A) THE VALUE OF THE BETS AND OR WAGERS YOU PLACED VIA YOUR ACCOUNT IN RESPECT OF THE RELEVANT BET/WAGER OR PRODUCT THAT GAVE RISE TO THE RELEVANT LIABILITY, OR<br /><br />



        (B) EURO €500 IN AGGREGATE, WHICHEVER IS LOWER.<br /><br />



        WE STRONGLY RECOMMEND THAT YOU (I) TAKE CARE TO VERIFY THE SUITABILITY AND COMPATIBILITY OF THE SERVICE WITH YOUR OWN COMPUTER EQUIPMENT PRIOR TO USE; AND<br /><br />

        (II) TAKE REASONABLE PRECAUTIONS TO PROTECT YOURSELF AGAINST HARMFUL PROGRAMS OR DEVICES INCLUDING THROUGH INSTALLATION OF ANTI-VIRUS SOFTWARE.<br /><br />



        <h4><b> Gambling By Those Under Age</b></h4><br />

        If we suspect that you are or receive notification that you are currently under 18 years or were under 18 years (or below the age of majority as stipulated in the laws of the jurisdiction applicable to you) when you placed any bets through the service your account will be suspended to prevent you placing any further bets or making any withdrawals from your account. We will then investigate the matter, including whether you have been betting as an agent for, or otherwise on behalf, of a person under 18 years (or below the age of majority as stipulated in the laws of the jurisdiction applicable to you). If having found that you: (a) are currently; (b) were under 18 years or below the majority age which applies to you at the relevant time; or © have been betting as an agent for or at the behest of a person under 18 years or below the majority age which applies:<br /><br />

        all winnings currently or due to be credited to your account will be retained;<br /><br />

        all winnings gained from betting through the service whilst under age must be paid to us on demand (if you fail to comply with this provision we will seek to recover all costs associated with recovery of such sums); and/or<br /><br />

        iii. any monies deposited in your site account which are not winnings will be returned to you.<br /><br />

        This condition also applies to you if you are over the age of 18 years but you are placing your bets within a jurisdiction which specifies a higher age than 18 years for legal betting and you are below that legal minimum age in that jurisdiction.<br /><br />

        In the event we suspect you are in breach of the provisions of this Clause 15 or are attempting to rely on them for a fraudulent purpose, we reserve the right to take any action necessary in order to investigate the matter, including informing the relevant law enforcement agencies.
    </div>
</ng-template>
<ng-template #privacyModal>
    <div class="modal-header">
        <h4 class="modal-title mt-0">Privacy Policy</h4>
        <button type="button" class="close" (click)="modalRef?.hide()">×</button>
    </div>
    <div class="modal-body">
        Any information provided to us by you will be protected and processed in strict accordance with these Terms and our Privacy Policy. <br /><br />

        We will not reveal the identity of any person who places bets using the service unless the information is lawfully required by competent authorities such as Regulators, the Police (e.g. to investigate fraud, money laundering or sports integrity issues), or by Financial Entities such as banks or payment suppliers or as permitted from time to time pursuant to the Privacy Policy.<br /><br />

        Upon registration,  your information will be stored in our database. This means that your personal information may be transferred outside the European Economic Area (EEA) to jurisdictions that may not provide the same level of protection and security as applied within the EU or EEA. By agreeing to these Terms you agree to the transfer of your personal information for the purpose of the provision of the Service object of this agreement and as further detailed in our Privacy Policy.<br /><br />

        <h4><b> Your Account</b></h4><br />

        We accept Accounts in multiple currencies, please refer to:  <br /><br />

        site account balances and transactions appear in the currency selected when the account was originally opened.<br /><br />

        We do not give credit for the use of the service.<br /><br />

        We may close or suspend an Account and refund any monies held if you are not or we reasonably believe that you are not complying with these Terms, or to ensure the integrity or fairness of the Service or if we have other reasonable grounds to do so. We may not always be able to give you prior notice.<br />

        We reserve the right to suspend an account without prior notice and return all funds. Contractual obligations already matured will however be honoured.<br />

        We reserve the right to refuse, restrict, cancel or limit any wager at any time for whatever reason, including any bet perceived to be placed in a fraudulent manner in order to circumvent our betting limits and/ or our system regulations.<br />

        If we close or suspend your account due to you not complying with these terms, we may cancel and/or void any of your bets.<br /><br />

        If any amount is mistakenly credited to your account it remains our property and when we become aware of any such mistake, we shall notify you and the amount will be withdrawn from your Account.<br />

        If, for any reason, your account goes overdrawn, you shall be in debt to us for the amount overdrawn.<br /><br />

        You must inform us as soon as you become aware of any errors with respect to your Account.<br /><br />

        Customers have the right to self-exclude themselves from site.. These requests have to be received from the Customer’s Registered Email Address and have to be sent to [email protected]<br /><br />

        Customers may set limitations on the amount they may wager and lose. Such request has to be sent from the Customer’s Registered Email Address to [email protected] Implementation and increasing of limits shall be processed diligently, however, any request for removing or reducing limitations shall be done after a cooling-off period of seven days following your request.<br /><br />

        You cannot transfer, sell, or pledge Your Account to another person. This prohibition includes the transfer of any assets of value of any kind, including but not limited to ownership of accounts, winnings, deposits, bets, rights and/or claims in connection with these assets, legal, commercial or otherwise. The prohibition on said transfers also includes however is not limited to the encumbrance, pledging, assigning, usufruct, trading, brokering, hypothecation and/or gifting in cooperation with a fiduciary or any other third party, company, natural or legal individual, foundation and/or association in any way shape or form.<br /><br />

        Should you wish to close your account with us, please send an email from your Registered Email Address to [email protected]<br /><br />



        <h4><b>Deposit of Funds</b></h4><br />

        You may deposit funds into your Account by any of the methods set out on our Website. All deposits should be made in the same currency as your Account and any deposits made in any other currency will be converted using the daily exchange rate obtained from www.xe.com, or at our own bank’s prevailing rate of exchange following which your Account will be deposited accordingly.<br /><br />

        Fees and charges may apply to customer’s deposits and withdrawals. Fee and charge details can be found here: site. Any deposit made to an account which is not rolled over (risked) three times will incur a 3% processing fee and any applicable withdrawal fee. You are responsible for your own bank charges that you may incur due to depositing funds with us. Exceptions to this rule are outlined in our “Payment Options” pages.<br /><br />

        site is not a financial institution and uses a third party electronic payment processors to process credit and debit card deposits; they are not processed directly by us. If you deposit funds by either a credit card or a debit card, your Account will only be credited if we receive an approval and authorisation code from the payment issuing institution. If your card’s issuer gives no such authorisation, your account will not be credited with those funds.<br /><br />

        Your funds are deposited and held in the respective client account based on the currency of your account.<br /><br />

        We are not a financial institution and you will not be entitled to any interest on any outstanding account balances and any interest accrued on the client accounts will be paid to us.<br /><br />

        Funds originating from ill-gotten means must not be deposited with us.<br /><br />

        <h4><b>Withdrawal of Funds</b></h4><br />

        You may withdraw any or all of your account Balance within the transaction maximums as shown on the Website here: site. Note that fees may apply as outlined in section 7.b.<br /><br />

        All withdrawals must be made in the currency of your account, unless otherwise stipulated by us.<br /><br />

        We reserve the right to request documentation for the purpose of identity verification prior to granting any withdrawals from your Account. We also reserve our rights to request this documentation at any time during the lifetime of your relationship with us.<br /><br />

        All withdrawals must be made to the original debit, credit card, bank account, method of payment used to make the payment to your site Account. We may, and always at our own discretion, allow you to withdraw to a payment method from which your original deposit did not originate. This will always be subject to additional security checks.<br /><br />

        Should you wish to withdraw funds but your account is either inaccessible, dormant, locked or closed, please contact our Customer Service Department at [email protected]<br /><br />

        <h4><b> Payment Transactions and Processors</b></h4><br />

        You are fully responsible for paying all monies owed to us. You must make all payments to us in good faith and not attempt to reverse a payment made or take any action which will cause such payment to be reversed by a third party in order to avoid a liability legitimately incurred. You will reimburse us for any charge-backs, denial or reversal of payment you make and any loss suffered by us as a consequence thereof. We reserve the right to also impose an administration fee of $50, or currency equivalent per charge-back, denial or reversal of payment you make.<br /><br />

        We reserve the right to use third party electronic payment processors and or merchant banks to process payments made by you and you agree to be bound by their terms and conditions providing they are made aware to you and those terms do not conflict with these Terms.<br /><br />

        All transactions made on our site might be checked to prevent money laundering or terrorism financing activity. Suspicious transactions will be reported to the relevant authority depending on the jurisdiction governing the transaction.<br /><br />

        <h4><b> Errors</b></h4><br />

        In the event of an error or malfunction of our system or processes, all bets are rendered void. You are under an obligation to inform us immediately as soon as you become aware of any error with the service. In the event of communication or system errors or bugs or viruses occurring in connection with the service and/or payments made to you as a result of a defect or effort in the Service, we will not be liable to you or to any third party for any direct or indirect costs, expenses, losses or claims arising or resulting from such errors, and we reserve the right to void all games/bets in question and take any other action to correct such errors.<br /><br />

        In the event of a casino system malfunction, or disconnection issues, all bets are rendered void. In the event of such error or any system failure or game error that results in an error in any odds calculation, charges, fees, rake, bonuses or payout, or any currency conversion as applicable, or other casino system malfunction (the “Casino Error”), we reserve the right to declare null and void any wagers or bets that were the subject of such Casino Error and to take any money from your Account relating to the relevant bets or wagers.<br /><br />

        We make every effort to ensure that we do not make errors in posting lines. However, if as a result of human error or system problems a bet is accepted at an odd that is: materially different from those available in the general market at the time the bet was made; or clearly incorrect given the chance of the event occurring at the time the bet was made then we reserve the right to cancel or void that wager, or to cancel or void a wager made after an event has started.<br /><br />


        We have the right to recover from you any amount overpaid and to adjust your account to rectify any mistake. An example of such a mistake might be where a price is incorrect or where we enter a result of an event incorrectly. If there are insufficient funds in your Account, we may demand that you pay us the relevant outstanding amount relating to any erroneous bets or wagers. Accordingly, we reserve the right to cancel, reduce or delete any pending plays, whether placed with funds resulting from the error or not.<br /><br />
    </div>
</ng-template>